(function() {
  'use strict';

  angular.module('component.sqlreports', []);
})();
